import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Badge,Card,Divider,IconButton,ImageList,ImageListItem,Stack,Typography,} from "@mui/material";
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { useTranslation } from 'react-i18next';

export default function ImagesList({ images, setImages, open, setOpen, disabled = false }: { images: File[], setImages: Function, open: boolean, setOpen: Function, disabled?: boolean }) {
  const { t } = useTranslation('translation');

  return (
    <Card>
      <Stack direction='row' alignItems='center' justifyContent='space-between' width='100%' height={60} paddingLeft={2} paddingRight={2}>
        <Stack direction='row' alignItems='center' justifyContent='flex-start' spacing={2}>
          <Badge color='primary' badgeContent={images?.length} />
          <Typography color='textDisabled' fontSize={12} fontWeight={600}>{t('notifications.ticket.imagesAdded')}</Typography>
        </Stack>
        {!open ?
          <IconButton disabled={disabled} onClick={() => setOpen()}>
            <AddIcon />
          </IconButton>
          : <IconButton disabled={disabled} onClick={() => setOpen()}>
            <RemoveIcon />
          </IconButton>}
      </Stack>
      {open &&
        <>
          <Divider variant='middle' orientation='horizontal' flexItem />
          <ImageList cols={3} rowHeight={150} sx={{ padding: 2 }}>
            {images.map((image, index) => (
              <ImageListItem key={`${image.name}|${index}`} sx={{ borderRadius: 2 }}>
                <ImageListItemBar
                  sx={{
                    borderRadius: 2,
                    background:
                      'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
                      'rgba(0,0,0,0.3) 40%, rgba(0,0,0,0) 100%)',
                  }}
                  actionPosition='right'
                  position='top'
                  actionIcon={
                    <IconButton color="error" disabled={disabled} onClick={() => setImages(Array.from(images).filter((elem) => elem !== image))}>
                      <RemoveCircleIcon />
                    </IconButton>
                  }
                />
                <img
                  width={150}
                  height={150}
                  style={{ objectFit: 'scale-down' }}
                  srcSet={`${image}?w=150&h=150&fit=crop&auto=format&dpr=2 2x`}
                  src={URL.createObjectURL(image)}
                  alt={image.name}
                  loading="lazy"
                />
              </ImageListItem>
            ))}
          </ImageList>
        </>
      }
    </Card>
  );
}
